<template>
  <div class="content">
    <msg-menu></msg-menu>

    <div class="tabs messages-tabs-content">
      <div id="tab-messages" class="tab active clearfix">
        <div class="d-block d-block-msg shadow-md">
          <div class="msg-title">
            <div class="row">
              <div class="col-sm-6">
                <h1>Messages Inbox<!--span>1 Unread</span--></h1>
              </div>
              <div class="col-sm-6 text-right">
                <router-link :to="{name: 'messagesNew'}" class="btn btn-sm">
                  <span class="plus-icon plus-icon-black"></span> New Message
                </router-link>
              </div>
            </div>
          </div>

          <div class="msg-main "
               :class="{'msg-welcome': !activeThread}"
          >
            <div class="msg-top">
              <div class="msg-search">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="search"><input class="input-sm msg-contacts-filter" v-model="threadFilter" type="text"
                                               placeholder="Search">
                    </div>
                  </div>
                  <div class="col-sm-6 select-filter">
                    <select class="input-sm choices-messages-filter">
                      <option value="msg_on">Messages On</option>
                      <option value="msg_off">Messages Off</option>
                      <option value="all">All Messages</option>
                      <option value="unread">Unread Messages</option>
                      <option value="unaddressed">Unaddressed Messages</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="msg-info">
                <div class="row" v-if="activeThread" >
                  <div class="col-sm-6">
                    <span v-on:click.prevent="showDonorSidebar(activeThread.uid)"
                          style="cursor: pointer"
                    >{{activeThread.first_name}} {{activeThread.last_name}}</span>
                      <br><span style="font-size: 12px;">{{activeThread | phoneNumberFormat}}</span>
                  </div>
                  <div class="col-sm-6 text-right">
                    <div
                        class="dropdown payouts-report-dropdown"
                    >
                      <span class="dropbtn dropbtn-only-one" :data-dropdown="`.select-msg`"></span>
                      <div :class="`dropdown-content dropdown-right  select-msg`">
                        <a v-on:click.prevent="showDonorSidebar(activeThread.uid)"
                           href="#">
                          View Contact</a>
                        <a v-if="activeThread.notifications_enabled"
                           v-on:click.prevent="turnMessagesOffModal = true"
                           href="#">
                          Turn Off Message</a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>



            </div>
            <div class="msg-body">
              <div class="msg-contacts">

                <div class="contacts-inner">
                  <a href="#"
                     v-on:click.prevent="selectThread(thread)"
                     class="contact-item"
                     :class="{active: (activeThread && activeThread.uid == thread.uid)}"
                     v-for="(thread, index) in filteredThreads"
                     :key="index"
                  >
                    <div class="user-info clearfix">
                      <div class="avatar">
                        <img v-if="thread.profile_photo" :src="thread.profile_photo" width="46px" height="46px"
                             :alt="`${thread.first_name} ${thread.last_name}`">
                        <span v-else>{{{fname: thread.first_name, lname: thread.last_name} | shortName}}</span>
                      </div>
                      <div class="name">{{thread.first_name}} {{thread.last_name}}</div>
                      <div class="number">{{thread | phoneNumberFormat}}</div>
                    </div>
                    <span class="last-time">{{thread.timestamp | sinceTime(dateNow)}}</span>
                    <span v-if="thread.unread_count && !(activeThread && activeThread.uid == thread.uid)"
                          class="unread-count"></span>
                    <div class="text" v-html="previewLastMessage(thread)"></div>
                  </a>
                </div>
              </div>
              <div class="msg-list">
                <div class="list-inner">
                  <div class="msg-conversation">
                    <div class="msg-conversation-inner">
                      <div class="conversation-content-wrap">
                        <div class="conversation-default-content" v-if="!activeThread">
                          <img :src="require('../../assets/images/5.png')" width="400" alt="engage-messages"/>
                          <h2>Welcome to Messages</h2>
                          <p>Choose a user to respond to&nbsp; - &nbsp;OR&nbsp; - &nbsp;Send out a NEW Message</p>
                        </div>
                        <div :class="{hidden: !activeThread}" class="conversation-content">

                          <div v-for="(message, index) in messagesPrepared"
                               :key="index"
                               :class="{
                                 'msg-item': message.type == 'message',
                                 'msg-item-own': (message.type == 'message' && message.direction === 'outbound'),
                                 'delimiter': message.type == 'delimiter',
                                 'active': (message.type == 'delimiter' && message.isActive)
                               }">
                            <span v-if="message.type == 'delimiter'">{{message.title}}</span>

                            <div v-if="message.type == 'message'" class="avatar">

                              <img v-if="message.client && message.client.profile_photo"
                                   :src="message.client.profile_photo" width="46px" height="46px" alt="">
                              <img v-else-if="message.direction === 'inbound' && activeThread.profile_photo"
                                   :src="activeThread.profile_photo" width="46px" height="46px" alt="">

                              <span v-else>{{{fname: message.first_name, lname: message.last_name} | shortName}}</span>
                            </div>
                            <div v-if="message.type === 'message'" class="info">
                              <div class="h-line">{{message.first_name}} {{message.last_name}}
                                <span class="time">{{message.timestamp | dateFormat('h:mmA')}}</span>
                              </div>
                              <div class="text" v-html="message.innerHtml"></div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="msg-write">
                    <div class="msg-write-inner clearfix "
                         :class="{hidden: !activeThread.notifications_enabled }"
                    >
                      <div class="msg-attachment-wrap">
                        <attachment-edit v-if="attachmentInfo && attachmentInfo.type !== 'none'"
                                         :attachment-info="attachmentInfo"
                                         :charity-info="activeCharityInfo"
                                         v-on:remove-attachment="attachmentInfo = null"
                        ></attachment-edit>
                      </div>
                      <div v-if="imageIsLoading" class="progress-big">
                        <div class="progress">
                          <div class="progress-val" :style="{'width': imageLoadingPercent + '%'}"></div>
                        </div>
                      </div>

                      <div v-if="imageError" class="image-upload-error error-msg">{{imageError}}</div>

                      <div class="upload-textarea-wrap">
                        <div class="dropdown-attach-to-msg">
                          <a class="btn btn-sm btn-sm-bold btn-attach dropbtn"
                             data-dropdown=".select-actions"
                             href="#"></a>

                          <add-attachment
                              :charity-info="activeCharityInfo"
                              v-on:select-attachment="selectAttachment"
                              v-bind:imageError.sync="imageError"
                              v-bind:imageIsLoading.sync="imageIsLoading"
                              v-bind:imageLoadingPercent.sync="imageLoadingPercent"
                          ></add-attachment>
                        </div>

                        <!--<textarea name="new-msg" id="new-msg2" ></textarea>-->
                        <textarea class="new-msg auto-textarea submit-textarea "
                                  maxlength="1600"
                                  id="new-msg2"
                                  rows="1"
                                  placeholder="Type a message..."
                        ></textarea>

                        <!--button class="btn-icons btn-merge-tags tooltip-wrap"
                                v-on:mousedown.prevent="$refs.selectTag.toggle()">
                          <div class="tooltip">Customized Text</div>
                        </button-->
                      </div>
                      <div class="text-right btn-wrap">
                        <a href="#" v-on:click.prevent="isSelectTemplateModal = true"
                           class="add-templates tooltip-wrap">
                          <div class="tooltip">Use a Template</div>
                        </a>
                        <a href="#" v-on:click.prevent="submitTxtMsg" class="btn btn-sm tooltip-wrap">
                          <div class="tooltip">CTRL+Enter</div>
                          Send
                        </a>
                      </div>
                    </div>
                    <div v-if="!activeThread.notifications_enabled" class="msg-write-inner clearfix">
                      <p style="margin-bottom: 0;">Messages for this person have been turned OFF</p>
                      <span style="font-size: 12px;color: #677788;">They must opt back into messaging in order to receive messages again</span>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <donor-info v-if="showDonorInfo"
                :donor-id="showDonorId"
                v-on:close-info="showDonorInfo = false"
    ></donor-info>


    <el-dialog
        :visible.sync="isMsgSentModal"
        center
        width="500px"
        v-on:close="updateThreads"
    >
      <div class="text-center">
        <img class="inline"
             :src="require('../../assets/icons/invites.svg')"
             width="210px"
             height="207px"
             alt="Message Sent">
        <h2 class="text-lg font-semibold mt-3 mb-1.5">Message Sent</h2>
        <div class="text-sm opacity-80 -mb-5" v-html="msgSentText"><br>
          Due to message delivery times, this may take a few minutes to reach the recipients
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="isMsgSentModal = false">Got It!</el-button>
      </span>
    </el-dialog>

    <modal v-if="isSelectTemplateModal"
           v-on:close-modal="isSelectTemplateModal = false"
           v-on:use-template="useTemplate"
           :charity-info="activeCharityInfo"
           :folders="[...folders]"
           :modal-name="'select-template'"></modal>

    <modal v-if="turnMessagesOffModal"
           v-on:close-modal="turnMessagesOffModal = false"
           v-on:ok-modal="turnMessagesOffModal = false; activeThread?turnMessagesOff(activeThread.uid):'';"
           :modal-name="'message-turn-off'">
      <div slot="body" class="desc">
        Are you sure you would like to turn messages OFF for:
        <br><b>{{activeThread.first_name}} {{activeThread.last_name}}</b><br><br>
        <em>They'll no longer receive texts and this action can not be undone unless the user signs back up to receive
          texts</em>
      </div>
    </modal>
  </div>
</template>

<script>
  /*eslint-env jquery*/
  import {sendMessage, getFolders, getTemplate, getToken, patchDonorPhone} from '@/utils/api';
  import {getAttachmentBlock} from '@/utils/attachments';
  import {upScrollConversation} from '@/utils/messages';
  import MsgMenu from './menu.vue';
  import AttachmentEdit from './attachment-edit.vue';
  import DonorInfo from '../Parts/DonorInfo.vue';
  import AddAttachment from './add-attachment.vue';
  import Modal from '../Modal/index.vue';
  import emojione from 'emojione';
  import {mapState} from "vuex";

  const moment = require('moment');

  export default {
    name: 'Messages',
    props: ['sendMsg'],
    components: {
      MsgMenu,
      Modal,
      DonorInfo,
      AddAttachment,
      AttachmentEdit,
    },
    metaInfo: {
      title: 'Messages - Inbox',
    },
    mounted() {
      const self = this;
      this.updateThreads();

      getFolders().then(folders => {
        this.folders = folders;
      });

      if (this.$route.query.send_msg) {
        this.isMsgSentModal = true;
        this.msgSentText = this.$route.query.send_msg;

        let query = Object.assign({}, this.$route.query);
        delete query.send_msg;
        this.$router.replace({query});

        setTimeout(() => self.updateThreads(), 1000 * 7);
      }

      // eslint-disable-next-line
      this.choicesMessages = new Choices('.choices-messages-filter', {
        placeholder: false,
        searchEnabled: false,
        itemSelectText: '',
        shouldSort: false,
      });

      this.choicesMessages.passedElement.addEventListener('change', () => {
        self.threadFilterType = self.choicesMessages.getValue(true);
      });

      setInterval(() => self.dateNow = moment(), 15000);

      $('.new-msg').emojioneArea({
        pickerPosition: 'top',
        textcomplete: {
          placement: 'top',
        },
        filters: {
          symbols: {
            icon: 'heart',
          },
          flags: {
            icon: 'checkered_flag',
          },
        },
        events: {
          emojibtn_click: () => {
            $('.emojionearea').find('.emojionearea-button-close').click();
            self.onMsgChange();
          },
          change: () => self.onMsgChange(),
          keyup: () => self.onMsgChange(),
          keydown: (editor, e) => {
            if (e.keyCode === 13 && e.ctrlKey) {
              self.submitTxtMsg();
            }
            if (e.keyCode === 13 && !e.ctrlKey) {
              let editor = $('.new-msg').data('emojioneArea').editor[0];
              editor.closest('.emojionearea').style.height = (editor.clientHeight + 21) + 'px';
            }
          },
          paste: () => self.onMsgChange(),
        },
      });
    },
    methods: {
      turnMessagesOff(uid) {
        patchDonorPhone(uid).then(() => this.updateThreads(true));
      },
      useTemplate(template) {
        this.isSelectTemplateModal = false;

        getTemplate(template.id).then(template => {

          let msgText = template.body;
          let firstLine = msgText.split(/\r\n|\r|\n/)[0].trim();
          let attachmentInfo = getAttachmentBlock(firstLine, true);

          if ('type' in attachmentInfo && attachmentInfo.type !== 'none') {
            this.attachmentInfo = attachmentInfo;
          }

          $('.new-msg').data('emojioneArea').setText(msgText);

          this.onMsgChange();
        });
      },
      submitTxtMsg() {
        const self = this;
        let text = $('.new-msg').data('emojioneArea').getText().trim();

        if (text === '' || !this.activeThread) {
          return false;
        }

        let message = {
          body: text,
        };

        if (this.attachmentInfo && this.attachmentInfo.type !== 'none') {
          // If the link is an image, send it as an attachment
          if (this.attachmentInfo.type === 'add-photo') {
            message.attachment = [this.attachmentInfo.link];
          } else {
            // Otherwise, prepend it to the message body.
            message.body = `${this.attachmentInfo.link}` + '\r\n' + `${message.body}`;
          }
        }

        $('.new-msg').data('emojioneArea').editor.html('');
        this.onMsgChange();
        this.attachmentInfo = null;

        sendMessage(
          this.activeThread.uid,
          message,
        ).then((res) => {

          const tokenData = getToken().split('.');

          if (!tokenData) {
            return '';
          }

          const dataClient = JSON.parse(atob(tokenData[1]));

          if (message.body.includes('[')) {
            setTimeout(() => {
              self.$store.dispatch(
                'messages/updateThread',
                {uid: self.activeThread.uid, charity_id: self.activeCharityId},
                {root: true},
              );
            }, 800);
          } else {
            let newMessage = {
              body: message.body,
              id: res.mid,
              mid: res.mid,
              uid: this.activeThread.uid,
              timestamp: new Date().toISOString(),
              is_read: true,
              direction: 'outbound',
              client: {'uid': dataClient.client_id, 'first_name': dataClient.fname, 'last_name': dataClient.lname},
            };
            if ('attachment' in message) {
              newMessage.attachments = message.attachment;
            }
            this.$emit('add-new-message', newMessage);
          }
        });
      },
      onMsgChange: function() {
        let editor = $('.new-msg').data('emojioneArea').editor[0];
        if (Math.abs(editor.closest('.emojionearea').clientHeight - editor.clientHeight) > 5) {
          editor.closest('.emojionearea').style.height = (editor.clientHeight * 1 + 1) + 'px';
        }
        upScrollConversation();
      },
      selectAttachment: function(attachment) {
        this.imageError = '';
        this.attachmentInfo = attachment;
      },
      showDonorSidebar: function(donorId) {
        this.showDonorInfo = false;
        this.showDonorId = false;

        this.$nextTick(() => {
          this.showDonorInfo = true;
          this.showDonorId = donorId;
        });
      },
      selectThread(thread) {
        if (this.activeThread) {
          this.$store.commit('messages/markAsRead', {
            uid: this.activeThread.uid,
            charity_id: this.activeCharityId,
          });
        }
        this.activeThread = thread;

        this.$router.replace({query: {thread_id: thread.uid}});

        this.updateThread(this.activeThread);
      },
      updateThread(thread) {
        this.$store.dispatch(
          'messages/updateThreadIfEmpty',
          {uid: thread.uid, charity_id: this.activeCharityId},
          {root: true},
        );
      },
      updateThreads(forceRefreshActiveThread = false) {
        this.$store.dispatch('messages/updateThreads', {charity_id: this.activeCharityId}, {root: true}).then(() => {

          //select thread from query param
          if ((!this.activeThread || forceRefreshActiveThread) && this.$route.query.thread_id) {

            const tmpThread = this.$store.getters['messages/getThreads'](this.activeCharityId).
              reduce((res, item) => (parseInt(item.uid) === parseInt(this.$route.query.thread_id)) ? item : res, null);

            if (tmpThread) {
              this.selectThread(tmpThread);
            }
          }
        });
      },
      previewLastMessage: function(thread) {
        let lastMessage = thread.last_message ? thread.last_message.body : '';
        let firstLine = lastMessage.split(/\r\n|\r|\n/)[0].trim();
        let attachmentInfo = getAttachmentBlock(firstLine, true);

        if (attachmentInfo.type !== 'none') {
          lastMessage = lastMessage.replace(firstLine, '').trim();
        }

        let cutString = function(str) {
          return (str.length < 96) ? str : str.substr(0, 95) + '...';
        };

        // eslint-disable-next-line
        return emojione.unicodeToImage(cutString(lastMessage));
      },
    },
    filters: {
      phoneNumberFormat(thread) {
        return (thread.notifications_enabled && thread.phone_number) ?
          thread.phone_number.replace(/(\d{3})(\d{3})(\d{4,10})/, '$1-$2-$3') : 'Messages turned off'; // Use a generic message if the phone number is null.
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      filteredThreads() {
        let threads = JSON.parse(JSON.stringify(this.$store.getters['messages/getThreads'](this.activeCharityId)));

        let unreadByThreads = this.$store.getters['messages/getUnreadCount'](this.activeCharityId);

        threads = threads.map(thread => ({
          ...thread,
          unread_count: unreadByThreads[thread.uid] ? unreadByThreads[thread.uid] : 0,
        }));

        if (this.threadFilter) {
          const re = new RegExp(this.threadFilter, 'ig');

          threads = threads.filter(v => `${v.first_name} ${v.last_name}`.search(re) !== -1);
        }

        if (this.threadFilterType && this.threadFilterType !== 'all') {

          if (this.threadFilterType === 'unread') {
            threads = threads.filter(v => v.unread_count > 0);
          }

          if (this.threadFilterType === 'msg_on') {
            threads = threads.filter(v => v.notifications_enabled);
          }
          if (this.threadFilterType === 'msg_off') {
            threads = threads.filter(v => !v.notifications_enabled);
          }

          if (this.threadFilterType === 'unaddressed') {
            threads = threads.filter(v => v.last_message.direction === 'inbound');
          }
        }
        threads = threads.sort((a, b) => {
          let t1 = moment(a.timestamp);
          let t2 = moment(b.timestamp);

          if (t1 > t2) {
            return -1;
          } else if (t1 < t2) {
            return 1;
          }
          return 0;
        });
        return threads;
      },
      messagesPrepared: function() {
        let result = [];
        let prevDate = '';

        let messages = this.$store.getters['messages/getMessagesByThread'](this.activeThread.uid, this.activeCharityId);

        let prevMsgReadStatus = true;
        for (let i = messages.length - 1; i >= 0; i--) {
          let msg = Object.assign({}, messages[i]);

          msg.type = 'message';

          const days7ago = moment().subtract(7, 'days');
          const msgTime = moment(msg.timestamp);

          if (msgTime.format('YYYYMMDD') !== prevDate) {
            prevDate = msgTime.format('YYYYMMDD');

            let delimiter = {type: 'delimiter'};
            if (msgTime < days7ago) {
              delimiter.title = msgTime.format('MMMM D, YYYY');
            } else {
              if (msgTime.format('YYYYMMDD') === moment().format('YYYYMMDD')) {
                delimiter.title = 'Today';
              } else {
                delimiter.title = msgTime.format('dddd');
              }
            }
            result.push(delimiter);
          }

          if (prevMsgReadStatus === true && !!msg.is_read === false) {
            let delimiter = {type: 'delimiter'};
            delimiter.title = 'New Messages';
            delimiter.isActive = true;
            result.push(delimiter);
          }

          prevMsgReadStatus = !!msg.is_read;
          if (msg.direction === 'outbound') {
            msg['first_name'] = (msg.client.first_name ? msg.client.first_name : '');
            msg['last_name'] = (msg.client.last_name ? msg.client.last_name : '');
          } else {
            msg['first_name'] = this.activeThread.first_name;
            msg['last_name'] = this.activeThread.last_name;
          }

          let masText = msg.body;

          let firstLine = masText.split(/\r\n|\r|\n/)[0].trim();

          let attachmentHtml = getAttachmentBlock(firstLine);
          if (attachmentHtml !== '') {
            masText = masText.replace(firstLine, '').trim();
            masText = masText.replace(/(?:\r\n|\r|\n)/g, '<br />');
            masText += attachmentHtml;
          } else {
            masText = masText.replace(/(?:\r\n|\r|\n)/g, '<br />');
          }

          // handle images attached to the message
          if (msg.attachments) {
            msg.attachments.forEach((attachment) => {
              masText += `<br /><div class="loaded-media"><img src="${attachment}" ></div>`;
            });
          }
          msg['innerHtml'] = emojione.unicodeToImage(masText);

          result.push(msg);
        }

        this.$nextTick(() => {
          upScrollConversation();
          for (let i = 1; i <= 4; i++) {
            // eslint-disable-next-line
            setTimeout(() => upScrollConversation(), 150 * i);
          }
        });

        return result;
      },
    },
    watch: {
      'activeCharityId'(){
        this.activeThread = false;
        this.updateThreads();
        getFolders().then(folders => {
          this.folders = folders;
        });
      },
    },
    data() {
      return {
        choicesMessages: null,

        dateNow: moment(),
        activeThread: false,
        threadFilter: '',
        threadFilterType: 'all',

        showDonorInfo: false,
        showDonorId: null,

        attachmentInfo: null,

        imageIsLoading: false,
        imageLoadingPercent: 0,
        imageError: '',

        isMsgSentModal: false,
        msgSentText: '',

        isSelectTemplateModal: false,
        folders: [],

        turnMessagesOffModal: false,
      };
    },
  };
</script>
